import * as React from 'react';
import './TrialInstitutionItemPage.scss';
import { match } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import ReactTable, { Column, RowInfo } from 'react-table';
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import * as ReactTooltip from 'react-tooltip';
import Alert from 'react-s-alert';
import { ITrialInstitutionItemReduxFormState, initialTrialInstitutionItemState } from "../../../reducers/reactReduxForms/trialInstitutionItem";
import { IRegistrationElement, RegistrationFormComponent, IRegistrationGrid } from "../../../interfaces/forms/IRegistrationComponent";
import { renderFormControls, RegistrationComponent, getFormProperty, getFormPropertyLabel } from "../../../helpers/formHelper";
import { renderRegistrationFormSaveSuccess, renderRegistrationFormSaveWarning, renderRegistrationFormSaveError, renderRegistrationFormSaveBlock } from "../../../helpers/alert";
import { TextFormInput, TextAreaFormInput, DatePickerFormInputFabric, RadioButtonSetFormInput, SelectFormInput, DatePickerFormInput, DatePickerPartialFormInput, MaskedFormInput, NumberFormInput, CheckboxFormInput, StaticFormInput, GenericMultiFormGroup, ValidationMessage } from "../../../components/form/index";
import * as TrialInstitutionItemActions from '../../../actions/trialInstitutionItem';
import * as TrialInstitutionActions from '../../../actions/trialInstitution';
import * as TrialActions from '../../../actions/trial';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { Link } from "../../../components/routing/index";
import { findLookup, generateOptionsFromLookup } from "../../../helpers/lookupHelper";
import { convertToShortDateString, convertToDateTimeString, convertToApproximateDateString } from "../../../helpers/date";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import { setModalTitle } from "../../../helpers/modalHelper";
import { Modal, NotificationAlert } from "../../../components/common/index";
import * as AuthenticationHelper from '../../../helpers/authentication';
import { ModalSize } from '../../../enumerations/ModalSize';
import { Form, actions, Control } from 'react-redux-form';
import { TrialLayout } from '../../index';
import * as FormHelper from '../../../helpers/formHelper';
import { GridRemove } from "../../../enumerations/GridRemove";

interface ITrialInstitutionItemPageParams {
    trialId: number;
    trialInstitutionId: number;
    trialInstitutionItemId: number;
}

interface ITrialInstitutionItemPageProps {

    form: Dtos.TrialInstitutionItem & IRegistrationFormState;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    reduxFormState: ITrialInstitutionItemReduxFormState;

    location: Location;
    trialId: number;
    trialInstitutionId: number;
    trialInstitutionItemId: number;

    match: match<ITrialInstitutionItemPageParams>;
    history: History;

    // From state
    trialInstitutionItem: Dtos.TrialInstitutionItem;
    trial: Dtos.Trial;
    trialInstitution: Dtos.TrialInstitution;
    lookups: Dtos.Lookup[];

    loadingTrial: boolean;
    loadingTrialInstitution: boolean;

    loadingTrialInstitutionItem: boolean;
    loadTrialInstitutionItemSuccess: boolean;
    loadTrialInstitutionItemFailure: boolean;

    savingTrialInstitutionItem: boolean;
    saveTrialInstitutionItemSuccess: boolean;
    saveTrialInstitutionItemFailure: boolean;

    validationFailures: Dtos.ResponseError[];

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
}

interface ITrialInstitutionItemPageActions {
    clearTrialInstitutionItem: TrialInstitutionItemActions.ITrialInstitutionItemClearActionCreator;
    loadTrialInstitutionItem: TrialInstitutionItemActions.ITrialInstitutionItemLoadByIdActionCreator;
    saveTrialInstitutionItem: TrialInstitutionItemActions.ITrialInstitutionItemSaveActionCreator;

    clearTrial: TrialActions.ITrialClearActionCreator;
    loadTrial: TrialActions.ITrialLoadByIdActionCreator;

    clearTrialInstitution: TrialInstitutionActions.ITrialInstitutionClearActionCreator;
    loadTrialInstitution: TrialInstitutionActions.ITrialInstitutionLoadByIdActionCreator;

    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;
}

type TrialInstitutionItemPageProps = ITrialInstitutionItemPageProps & ITrialInstitutionItemPageActions;

const reduxFormName: string = "reduxForms.trialInstitutionItem";

class TrialInstitutionItemPage extends React.PureComponent<TrialInstitutionItemPageProps, any> {

    constructor(props: TrialInstitutionItemPageProps) {
        super(props);

        this.clearTrialInstitutionItem = this.clearTrialInstitutionItem.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.loadForm = this.loadForm.bind(this);
    }

    componentDidMount() {
        const {
            loadTrialInstitutionItem,
            trialInstitutionItemId,
            trialId,
            trialInstitutionId,
            loadTrialInstitution,
            loadTrial
        } = this.props;

        if (trialInstitutionItemId) {
            loadTrialInstitutionItem(trialInstitutionItemId);
        } 
        if (trialInstitutionId) {
            loadTrialInstitution(trialInstitutionId, false, false, false);
        }
        loadTrial(trialId, false, false, false, false, false);
    }

    componentDidUpdate(prevProps: TrialInstitutionItemPageProps, prevState) {
        const {
            form,
            trialId,
            trialInstitutionItemId,
            trialInstitutionItem,
            loadTrialInstitution,
            loadTrialInstitutionItem,
            trialInstitutionId,
            loadTrial,
            loadingTrialInstitutionItem,
            loadTrialInstitutionItemSuccess,
            savingTrialInstitutionItem,
            saveTrialInstitutionItemSuccess,
            validationFailures,
            navigate
        } = this.props;

        if (trialId && prevProps.trialId != trialId) {
            loadTrial(trialId, false, false, false, false, false);
        }

        if (trialInstitutionId && prevProps.trialInstitutionId != trialInstitutionId) {
            loadTrialInstitution(trialInstitutionId, false, false, false);
        }

        if (trialInstitutionItemId && prevProps.trialInstitutionItemId != trialInstitutionItemId) {
            loadTrialInstitutionItem(trialInstitutionItemId);
        }

        if (!loadingTrialInstitutionItem && prevProps.loadingTrialInstitutionItem) {
            if (loadTrialInstitutionItemSuccess) {
                this.loadForm();
            }
            else {

            }
        }


        if (!savingTrialInstitutionItem && prevProps.savingTrialInstitutionItem) {
            if (saveTrialInstitutionItemSuccess) {
                if (validationFailures && validationFailures.length > 0) {

                    Alert.warning(<NotificationAlert
                        alertContent={renderRegistrationFormSaveWarning(validationFailures)}
                        icon={FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE}
                    />);

                    // toggleMessageModal();

                } else {

                    Alert.success(<NotificationAlert
                        alertContent={renderRegistrationFormSaveSuccess()}
                        icon={FontAwesomeIcons.Solid.CHECK}
                    />);

                }
                if (form.saveAndReturn) {
                    navigate("/trials/" + trialId + "/trialinstitution/" + trialInstitutionId + "/items")
                } else if (!form.saveAndReturn && trialInstitutionItemId && trialInstitutionItemId > 0) {
                    this.loadForm();
                }
            }
            else {

                Alert.error(
                    <NotificationAlert
                        alertContent={this.renderErrorAlert()}
                        icon={FontAwesomeIcons.Solid.TIMES_OCTAGON}
                    />
                );

            }
        }
    }

    componentWillUnmount() {
        const {
            resetForm,
            loadForm
        } = this.props

        this.clearTrialInstitutionItem();
        loadForm(reduxFormName, initialTrialInstitutionItemState);
        resetForm(reduxFormName);
    }

    clearTrialInstitutionItem() {
        this.props.clearTrialInstitutionItem();
        this.props.clearTrialInstitution();
        this.props.clearTrial();
    }

    showTrialInstitutionItem(): boolean {
        const {
            loadingTrial,
            loadingTrialInstitution,
            loadingTrialInstitutionItem,
            loadTrialInstitutionItemSuccess
        } = this.props

        if (!loadingTrial && !loadingTrialInstitution && !loadingTrialInstitutionItem && loadTrialInstitutionItemSuccess) {
            return true;
        }

        return false;
    }

    render() {
        const {
            loadingTrial,
            loadingTrialInstitution,
            loadingTrialInstitutionItem,
        } = this.props;

        return <TrialLayout loading={loadingTrial || loadingTrialInstitution || loadingTrialInstitutionItem} permission={Dtos.Permission.TrialInstitutionItemInstanceView}>
            {this.renderContent()}
        </TrialLayout>;
    }

    renderContent() {
        const {
            form,
            lookups,
            validationFailures,
            formProperties,
            formState,
            changeForm,
            savingTrialInstitutionItem,
            permissions,
        } = this.props;

        let noPermissionToEditMessage = false;
        if ((form.id && form.id > 0) && validationFailures && validationFailures.filter(f => f.errorCode == "PR-005").length > 0) {
            noPermissionToEditMessage = true;
        }

        const hasPermission: boolean = form && form.trialInstitution && AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialInstitutionItemInstanceUpdate, form.trialInstitution.trialId, form.trialInstitution.institutionId)
        //const hasPermission: boolean = AuthenticationHelper.hasCreateEditPermission(form, permissions, Dtos.Permission.TrialInstitutionItemInstanceUpdate, Dtos.Permission.TrialInstitutionItemInstanceUpdate);
        const formDisabled: boolean = !hasPermission || savingTrialInstitutionItem || (formState && formState.formStatus == Dtos.FormStatus.Disabled) || noPermissionToEditMessage;

        let hideVersion: boolean = !(form && form.trialItem && form.trialItem.allowIntraVersions);

        let formComponents: { [index: string]: RegistrationFormComponent } = {
            trialItem: {
                type: RegistrationComponent.RegistrationGroupFormControls,
                components: {
                    name: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: TextFormInput,
                        inputDisabled: true,
                        size: 1
                    },
                }
            },
            descriptionGroup: {
                type: RegistrationComponent.RegistrationGroupFormControls,
                components: {
                    description: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: TextAreaFormInput,
                        inputDisabled: true,
                        size: 1,
                    },
                },
            },

            currentVersion: {
                type: RegistrationComponent.RegistrationGroupFormControls,
                components: {
                    version: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: TextFormInput,
                        inputDisabled: formDisabled,
                        size: 2,
                        hide: hideVersion
                    },
                },
                hide: hideVersion,
            },
            trialItemPreviousInstancesHeader: {
                type: RegistrationComponent.RegistrationElement,
                component: <div className="border-0 d-flex pt-4 ">
                    <h3>Previous Versions</h3>
                </div>
            },
            
            trialItemPreviousVersions: {
                type: RegistrationComponent.RegistrationGrid,
                label: "Versions",
                disabled: formDisabled || !hasPermission,
                formName: "TrialInstitutionItem",
                className: "",
                minRows: 0,
                columnStyles: [
                    {
                        width: 'auto'
                    },
                    {
                        width: "125px"
                    },
                ],
                removeConfig: !hasPermission ? GridRemove.None : GridRemove.All,
                hideAdd: true,
                components: {
                    version: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: TextFormInput,
                        inputDisabled: formDisabled || !hasPermission,
                        inputLabel: getFormPropertyLabel("TrialInstitutionItem", "Version", formProperties),
                    },
                },
                initialState: initialTrialInstitutionItemState,
                onRemove: (model: string) => {
                    console.log(model);
                    changeForm(model + ".active", false);
                    return true; // this was handled here
                },
                filterRow: (data: any) => {
                    if (data.active != true) {
                        return false
                    }
                    return true;
                }
            },
        };

        return <div>
            <div className="row">
                <div className={"col mb-2"}>
                    <h3>Trial Institution Item</h3>
                </div>
            </div>
            <Form model={reduxFormName}
                onSubmit={(val, event) => this.handleOnSubmit(val)}
                onSubmitFailed={(val) => this.handleOnSubmitFailed(val)}
            >
                {
                    renderFormControls(form, "trialInstitutionItem", formComponents, lookups, validationFailures, formProperties, changeForm)
                }

                <div className="mt-4 mb-4 text-right">
                    <button disabled={formDisabled}
                        onClick={
                            () => {
                                this.props.changeForm(reduxFormName + ".saveAndReturn", false);
                            }
                        }
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit
                    </button>

                    <button disabled={formDisabled}
                        onClick={() => {
                            this.props.changeForm(reduxFormName + ".saveAndReturn", true);
                        }}
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit And Return
                    </button>
                    <button onClick={this.onCancel} className="btn btn-primary mr-2" > Cancel </button>
                </div>
            </Form>
        </div>

    }

    renderErrorAlert(): any {

        const {
            validationFailures,
        } = this.props

        return <div>
            The form was <strong> not </strong> saved.
        </div>

    }

    renderWarningAlert(): any {

        const {
            validationFailures,
        } = this.props

        return <div>
            The form was saved but was invalid with {validationFailures.length} errors.
        </div>

    }

    renderSaveSuccessAlert(): any {
        return <div>The form has been saved successfully</div>
    }

    handleOnSubmit(data: Dtos.TrialInstitutionItem) {
        const {
            saveTrialInstitutionItem
        } = this.props;

        if (data) {
            let changes: Dtos.TrialInstitutionItem = {} as Dtos.TrialInstitutionItem;
            saveTrialInstitutionItem(Object.assign({ ...data }, changes));
        }
    }

    handleOnSubmitFailed(data: Dtos.Trial) {
        Alert.error(<NotificationAlert
            minWidth={500}
            alertContent={renderRegistrationFormSaveBlock()}
            icon={FontAwesomeIcons.Solid.BAN}
        />);
    }

    onCancel() {
        const {
            trialId,
            trialInstitutionId,
            navigate
        } = this.props;

        navigate("/trials/" + trialId + "/trialinstitution/" + trialInstitutionId + "/items");
    }

    loadForm() {
        const {
            loadForm,
            trialInstitutionItem,
        } = this.props

        let extraData: Dtos.TrialInstitutionItem = {} as Dtos.TrialInstitutionItem;

        loadForm(reduxFormName, Object.assign({ ...trialInstitutionItem }, extraData));
    }
}


const mapStateToProps = (state: ITmdState, ownProps: TrialInstitutionItemPageProps): ITrialInstitutionItemPageProps => {

    let trialInstitutionItem: Dtos.TrialInstitutionItem | undefined = !(state.trialInstitutionItem.formData instanceof Array) ? state.trialInstitutionItem.formData : undefined;
    let trialInstitution: Dtos.TrialInstitution | undefined = !(state.trialInstitution.formData instanceof Array) ? state.trialInstitution.formData : undefined;
    let trial: Dtos.Trial | undefined = !(state.trials.formData instanceof Array) ? state.trials.formData : undefined;
    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];

    return {

        match: ownProps.match,
        trialId: ownProps.match ? ownProps.match.params.trialId : undefined!,
        trialInstitutionId: ownProps.match ? ownProps.match.params.trialInstitutionId : undefined!,
        trialInstitutionItemId: ownProps.match ? ownProps.match.params.trialInstitutionItemId : undefined!,

        history: ownProps.history,
        location: state.routing.location,

        trialInstitutionItem: trialInstitutionItem!,
        trial: trial!,
        trialInstitution: trialInstitution!,

        loadingTrialInstitutionItem: state.trialInstitutionItem.loadState && state.trialInstitutionItem.loadState.status == RequestState.Pending,
        loadTrialInstitutionItemSuccess: state.trialInstitutionItem.loadState && state.trialInstitutionItem.loadState.status == RequestState.Success,
        loadTrialInstitutionItemFailure: state.trialInstitutionItem.loadState && state.trialInstitutionItem.loadState.status == RequestState.Failure,

        savingTrialInstitutionItem: state.trialInstitutionItem.saveState && state.trialInstitutionItem.saveState.status == RequestState.Pending,
        saveTrialInstitutionItemSuccess: state.trialInstitutionItem.saveState && state.trialInstitutionItem.saveState.status == RequestState.Success,
        saveTrialInstitutionItemFailure: state.trialInstitutionItem.saveState && state.trialInstitutionItem.saveState.status == RequestState.Failure,

        loadingTrial: state.trials.loadState && state.trials.loadState.status == RequestState.Pending,
        loadingTrialInstitution: state.trialInstitution.loadState && state.trialInstitution.loadState.status == RequestState.Pending,

        user: state.user.data,
        permissions: permissions,
        lookups: state.trialInstitutionItem.lookups,

        form: state.reduxForms.trialInstitutionItem,
        formState: state.trialInstitutionItem.formState,
        formProperties: state.trialInstitutionItem.formProperties,

        reduxFormState: state.reduxForms.formState.trialInstitutionItem,
        validationFailures: trialInstitutionItem ?
            state.trialInstitutionItem.validationFailures :
            undefined,

    };
};

const mapDispatchToProps = (dispatch): ITrialInstitutionItemPageActions => {
    return {
        navigate: bindActionCreators(routerActions.push, dispatch),
        navigateReplace: bindActionCreators(routerActions.replace, dispatch),

        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),

        loadTrialInstitutionItem: bindActionCreators(TrialInstitutionItemActions.LoadTrialInstitutionItemById, dispatch),
        clearTrialInstitutionItem: bindActionCreators(TrialInstitutionItemActions.Clear, dispatch),
        saveTrialInstitutionItem: bindActionCreators(TrialInstitutionItemActions.SaveTrialInstitutionItem, dispatch),

        loadTrial: bindActionCreators(TrialActions.LoadTrialById, dispatch),
        clearTrial: bindActionCreators(TrialActions.Clear, dispatch),

        loadTrialInstitution: bindActionCreators(TrialInstitutionActions.LoadTrialInstitutionById, dispatch),
        clearTrialInstitution: bindActionCreators(TrialInstitutionActions.Clear, dispatch),

    };
};

export default
    connect(mapStateToProps, mapDispatchToProps)(TrialInstitutionItemPage);
